// TECHSPR Enterprise Website - Complete Mock Data

export const companyInfo = {
  name: "TECHSPR IT Private Limited",
  tagline: "Best Update For You",
  description: "A trusted Digital Engineering and Enterprise Modernization partner.",
  stats: {
    revenue: "$506.8M",
    marketCap: "$10.2B",
    experts: "28,000+",
    countries: "20"
  },
  contact: {
    email: "info@techspr.net",
    phone: "+916306445424"
  }
};

export const services = [
  {
    id: "ai-services",
    name: "TECHSPR.AI",
    slug: "ai-services",
    icon: "Brain",
    shortDescription: "Transform your AI journey with cutting-edge artificial intelligence solutions.",
    description: "Harness the power of AI to revolutionize your business operations, from generative AI to enterprise-ready machine learning solutions.",
    capabilities: [
      "Enterprise AI Readiness",
      "Agentic AI",
      "GenAI Hub",
      "AI Governance & Ethics",
      "Domain-Specific AI Models"
    ],
    benefits: [
      "30% increase in operational efficiency",
      "Faster time-to-market for AI initiatives",
      "Reduced AI implementation costs",
      "Enhanced decision-making capabilities"
    ],
    useCases: [
      "Intelligent document processing",
      "Predictive maintenance",
      "Customer sentiment analysis",
      "AI-powered chatbots and virtual assistants"
    ]
  },
  {
    id: "software-product-engineering",
    name: "Software Product Engineering",
    slug: "software-product-engineering",
    icon: "Code",
    shortDescription: "Build resilient, scalable software products that drive business growth.",
    description: "From concept to deployment, we engineer software products that meet the highest standards of quality, performance, and user experience.",
    capabilities: [
      "Product & Platform Strategy",
      "Product & Platform Engineering",
      "Product Modernization",
      "Product Sustenance & Support",
      "DevOps & CI/CD"
    ],
    benefits: [
      "50% faster product development cycles",
      "Improved product quality and reliability",
      "Reduced technical debt",
      "Enhanced customer satisfaction"
    ],
    useCases: [
      "SaaS platform development",
      "Mobile app engineering",
      "Legacy system modernization",
      "API-first architecture implementation"
    ]
  },
  {
    id: "cloud-infrastructure",
    name: "Cloud & Infrastructure",
    slug: "cloud-infrastructure",
    icon: "Cloud",
    shortDescription: "Modernize your infrastructure with cloud-native solutions.",
    description: "Transform your IT infrastructure with cloud migration, hybrid cloud solutions, and intelligent operations management.",
    capabilities: [
      "Hybrid & Multi-Cloud Transformation",
      "Data Center Modernization",
      "Intelligent IT Operations",
      "Cloud Advisory Services",
      "FinOps & Cost Optimization"
    ],
    benefits: [
      "40% reduction in infrastructure costs",
      "99.9% system uptime",
      "Scalable and flexible infrastructure",
      "Enhanced security and compliance"
    ],
    useCases: [
      "Cloud migration and optimization",
      "Kubernetes implementation",
      "Infrastructure as Code (IaC)",
      "Disaster recovery planning"
    ]
  },
  {
    id: "data-analytics",
    name: "Data & Analytics",
    slug: "data-analytics",
    icon: "BarChart3",
    shortDescription: "Unlock the power of your data with advanced analytics.",
    description: "Turn data into actionable insights with modern data platforms, analytics, and machine learning capabilities.",
    capabilities: [
      "Data & Analytics Advisory",
      "Data Stack Modernization",
      "Data Science & Machine Learning",
      "Data Connectors & Certification",
      "Data Strategy and Governance"
    ],
    benefits: [
      "Real-time data-driven decision making",
      "Improved data quality and accessibility",
      "Predictive analytics capabilities",
      "Reduced data processing time by 60%"
    ],
    useCases: [
      "Data warehouse modernization",
      "Real-time analytics dashboards",
      "Customer 360 platforms",
      "Predictive analytics models"
    ]
  },
  {
    id: "consulting",
    name: "Enterprise Consulting",
    slug: "consulting",
    icon: "Lightbulb",
    shortDescription: "Strategic guidance for digital transformation initiatives.",
    description: "Partner with our consultants to design and execute comprehensive digital transformation strategies.",
    capabilities: [
      "Innovation Strategy",
      "Experience Transformation",
      "Next-Gen Business Transformation",
      "Change Management",
      "Technology Advisory"
    ],
    benefits: [
      "Accelerated transformation timelines",
      "Reduced transformation risks",
      "Improved stakeholder buy-in",
      "Measurable business outcomes"
    ],
    useCases: [
      "Digital transformation roadmap",
      "Operating model redesign",
      "Technology stack rationalization",
      "Change management programs"
    ]
  },
  {
    id: "cx-transformation",
    name: "CX Transformation",
    slug: "cx-transformation",
    icon: "Users",
    shortDescription: "Deliver exceptional customer experiences across all touchpoints.",
    description: "Transform customer engagement with CRM platforms, customer analytics, and omnichannel experiences.",
    capabilities: [
      "CX Strategy",
      "Salesforce Cloud Implementation",
      "CX Platform Integration",
      "Customer Analytics & Insights",
      "Omnichannel Experience Design"
    ],
    benefits: [
      "30% increase in customer satisfaction",
      "Improved customer retention rates",
      "Unified customer view across channels",
      "Faster customer service resolution"
    ],
    useCases: [
      "CRM implementation and optimization",
      "Customer journey mapping",
      "Personalization engines",
      "Contact center modernization"
    ]
  },
  {
    id: "intelligent-automation",
    name: "Intelligent Automation",
    slug: "intelligent-automation",
    icon: "Zap",
    shortDescription: "Automate processes with RPA and intelligent workflows.",
    description: "Drive efficiency and reduce costs with robotic process automation, workflow automation, and low-code platforms.",
    capabilities: [
      "Business Process Management",
      "Robotic Process Automation",
      "Low Code Application Development",
      "Conversational AI",
      "Process Mining & Optimization"
    ],
    benefits: [
      "70% reduction in manual processing time",
      "Improved accuracy and compliance",
      "Faster process execution",
      "Enhanced employee productivity"
    ],
    useCases: [
      "Invoice processing automation",
      "Customer onboarding workflows",
      "Chatbot development",
      "Data entry automation"
    ]
  },
  {
    id: "enterprise-security",
    name: "Enterprise IT Security",
    slug: "enterprise-security",
    icon: "Shield",
    shortDescription: "Protect your enterprise with comprehensive security solutions.",
    description: "Secure your digital assets with managed security services, compliance solutions, and identity management.",
    capabilities: [
      "Managed Security Services",
      "Security Assurance & Data Security",
      "Governance, Risk & Compliance",
      "Identity Access Management",
      "Threat Intelligence & Response"
    ],
    benefits: [
      "Enhanced security posture",
      "Reduced security incidents by 60%",
      "Improved compliance adherence",
      "24/7 security monitoring"
    ],
    useCases: [
      "Security operations center (SOC)",
      "Zero-trust architecture",
      "Compliance automation",
      "Security awareness training"
    ]
  },
  {
    id: "application-development",
    name: "Application Development & Management",
    slug: "application-development",
    icon: "Smartphone",
    shortDescription: "Build and manage enterprise applications at scale.",
    description: "Develop, modernize, and manage mission-critical applications that drive business value.",
    capabilities: [
      "Application & Platform Development",
      "Application Modernization",
      "Application Maintenance & Support",
      "Application Portfolio Rationalization",
      "API Management"
    ],
    benefits: [
      "Faster application delivery",
      "Reduced maintenance costs",
      "Improved application performance",
      "Better user experience"
    ],
    useCases: [
      "Legacy application modernization",
      "Microservices architecture",
      "Mobile-first applications",
      "Application performance monitoring"
    ]
  },
  {
    id: "enterprise-integration",
    name: "Enterprise Integration",
    slug: "enterprise-integration",
    icon: "Network",
    shortDescription: "Connect systems and data across your enterprise.",
    description: "Enable seamless data flow and system integration across your technology landscape.",
    capabilities: [
      "API Integration",
      "Enterprise Service Bus (ESB)",
      "iPaaS Solutions",
      "B2B Integration",
      "Legacy System Integration"
    ],
    benefits: [
      "Unified data across systems",
      "Reduced integration complexity",
      "Faster time-to-integrate",
      "Improved data quality"
    ],
    useCases: [
      "ERP integration",
      "Cloud-to-cloud integration",
      "Data synchronization",
      "Partner ecosystem integration"
    ]
  },
  {
    id: "global-capability-centers",
    name: "Global Capability Centers",
    slug: "global-capability-centers",
    icon: "Globe",
    shortDescription: "Build and scale your global delivery capabilities.",
    description: "Establish high-performing global capability centers that drive innovation and operational excellence.",
    capabilities: [
      "GCC Setup & Strategy",
      "Talent Acquisition & Development",
      "Process Optimization",
      "Technology Enablement",
      "Innovation Labs"
    ],
    benefits: [
      "Access to global talent pools",
      "Cost optimization",
      "24/7 operational capability",
      "Innovation acceleration"
    ],
    useCases: [
      "Offshore development centers",
      "Shared services setup",
      "Innovation hubs",
      "Center of excellence establishment"
    ]
  },
  {
    id: "open-source",
    name: "Open Source Hub",
    slug: "open-source",
    icon: "GitBranch",
    shortDescription: "Leverage open source technologies for enterprise innovation.",
    description: "Harness the power of open source with enterprise-grade support, customization, and integration.",
    capabilities: [
      "Open Source Strategy",
      "Enterprise Support",
      "Custom Development",
      "Migration Services",
      "Community Engagement"
    ],
    benefits: [
      "Reduced licensing costs",
      "Faster innovation cycles",
      "Vendor independence",
      "Active community support"
    ],
    useCases: [
      "Kubernetes implementation",
      "Open source migration",
      "Custom framework development",
      "DevOps toolchain setup"
    ]
  },
  {
    id: "experience-transformation",
    name: "Experience Transformation",
    slug: "experience-transformation",
    icon: "Palette",
    shortDescription: "Design immersive digital experiences that engage users.",
    description: "Create memorable digital experiences through UX design, immersive technologies, and experience platforms.",
    capabilities: [
      "UX/UI Design",
      "Immersive Technologies (AR/VR)",
      "Design Systems",
      "User Research & Testing",
      "Accessibility Design"
    ],
    benefits: [
      "Improved user engagement",
      "Higher conversion rates",
      "Enhanced brand perception",
      "Reduced support costs"
    ],
    useCases: [
      "Digital experience platforms",
      "AR/VR applications",
      "Design system implementation",
      "User experience optimization"
    ]
  },
  {
    id: "cx-contact-center",
    name: "CX Contact Center Intelligence",
    slug: "cx-contact-center",
    icon: "Phone",
    shortDescription: "Transform contact centers with AI-powered intelligence.",
    description: "Modernize contact center operations with AI, analytics, and omnichannel capabilities.",
    capabilities: [
      "AI-Powered Routing",
      "Voice Analytics",
      "Omnichannel Support",
      "Agent Assist",
      "Performance Analytics"
    ],
    benefits: [
      "Reduced average handle time",
      "Improved first call resolution",
      "Enhanced agent productivity",
      "Better customer satisfaction scores"
    ],
    useCases: [
      "Cloud contact center migration",
      "AI chatbot integration",
      "Real-time sentiment analysis",
      "Workforce optimization"
    ]
  }
];

export const industries = [
  {
    id: "banking-financial",
    name: "Banking & Financial Services",
    slug: "banking-financial",
    icon: "Building",
    description: "Accelerate digital transformation in banking and financial services with innovative solutions.",
    challenges: [
      "Legacy system modernization",
      "Regulatory compliance",
      "Customer experience enhancement",
      "Digital banking adoption"
    ],
    solutions: [
      "Core banking modernization",
      "Open banking platforms",
      "Digital lending solutions",
      "Risk & compliance automation",
      "Mobile banking apps"
    ],
    results: [
      "40% reduction in processing time",
      "Enhanced customer satisfaction",
      "Improved regulatory compliance",
      "Faster time-to-market for new products"
    ]
  },
  {
    id: "insurance",
    name: "Insurance",
    slug: "insurance",
    icon: "Shield",
    description: "Transform insurance operations with digital-first solutions.",
    challenges: [
      "Claims processing inefficiency",
      "Customer acquisition costs",
      "Fraud detection",
      "Legacy policy administration"
    ],
    solutions: [
      "Digital claims processing",
      "AI-powered underwriting",
      "Customer portals",
      "Fraud detection systems",
      "Policy administration modernization"
    ],
    results: [
      "60% faster claims processing",
      "Reduced operational costs",
      "Improved fraud detection",
      "Enhanced customer engagement"
    ]
  },
  {
    id: "healthcare",
    name: "Healthcare",
    slug: "healthcare",
    icon: "Heart",
    description: "Improve patient outcomes with healthcare technology solutions.",
    challenges: [
      "Patient data management",
      "Interoperability",
      "Care coordination",
      "Regulatory compliance"
    ],
    solutions: [
      "Electronic health records (EHR)",
      "Patient engagement platforms",
      "Telemedicine solutions",
      "Healthcare analytics",
      "Clinical decision support"
    ],
    results: [
      "Improved patient outcomes",
      "Enhanced care coordination",
      "Reduced administrative burden",
      "Better population health management"
    ]
  },
  {
    id: "life-sciences",
    name: "Life Sciences",
    slug: "life-sciences",
    icon: "FlaskConical",
    description: "Accelerate drug development and commercialization.",
    challenges: [
      "Clinical trial efficiency",
      "Drug discovery timelines",
      "Regulatory submissions",
      "Supply chain visibility"
    ],
    solutions: [
      "Clinical trial management",
      "AI-powered drug discovery",
      "Regulatory information management",
      "Commercial operations",
      "Pharmacovigilance systems"
    ],
    results: [
      "Faster time-to-market",
      "Improved trial success rates",
      "Enhanced regulatory compliance",
      "Better supply chain efficiency"
    ]
  },
  {
    id: "consumer-tech",
    name: "Consumer Tech",
    slug: "consumer-tech",
    icon: "Smartphone",
    description: "Build engaging consumer technology products and platforms.",
    challenges: [
      "User engagement",
      "Scalability",
      "Personalization",
      "Data privacy"
    ],
    solutions: [
      "Mobile app development",
      "Personalization engines",
      "E-commerce platforms",
      "Streaming solutions",
      "IoT integrations"
    ],
    results: [
      "Increased user engagement",
      "Higher conversion rates",
      "Improved scalability",
      "Enhanced user experience"
    ]
  },
  {
    id: "industrial",
    name: "Industrial",
    slug: "industrial",
    icon: "Factory",
    description: "Drive Industry 4.0 transformation with smart manufacturing.",
    challenges: [
      "Equipment downtime",
      "Supply chain disruptions",
      "Quality control",
      "Workforce safety"
    ],
    solutions: [
      "Predictive maintenance",
      "Digital twins",
      "Supply chain optimization",
      "Quality management systems",
      "IoT sensor networks"
    ],
    results: [
      "Reduced equipment downtime",
      "Improved product quality",
      "Enhanced supply chain visibility",
      "Better workforce safety"
    ]
  },
  {
    id: "software-hitech",
    name: "Software & Hi-Tech",
    slug: "software-hitech",
    icon: "Cpu",
    description: "Accelerate product innovation in software and high-tech industries.",
    challenges: [
      "Time-to-market pressure",
      "Technical debt",
      "Scalability requirements",
      "Customer expectations"
    ],
    solutions: [
      "Agile product development",
      "Cloud-native architecture",
      "DevOps automation",
      "Technical debt reduction",
      "SaaS platform development"
    ],
    results: [
      "50% faster product releases",
      "Improved product quality",
      "Enhanced scalability",
      "Better customer satisfaction"
    ]
  },
  {
    id: "telecom-media",
    name: "Telecom & Media",
    slug: "telecom-media",
    icon: "Radio",
    description: "Transform telecom and media operations for the digital age.",
    challenges: [
      "Network modernization",
      "Content delivery",
      "Customer churn",
      "5G adoption"
    ],
    solutions: [
      "Network automation",
      "Content management platforms",
      "Customer analytics",
      "5G network solutions",
      "OTT platforms"
    ],
    results: [
      "Improved network performance",
      "Enhanced content delivery",
      "Reduced customer churn",
      "Faster 5G deployment"
    ]
  }
];

export const caseStudies = [
  {
    id: "cs-1",
    client: "Global Bank",
    industry: "Banking & Financial Services",
    title: "Digital Banking Transformation Drives 60% Increase in Customer Engagement",
    challenge: "A leading global bank needed to modernize its legacy core banking system and launch a digital-first banking experience to compete with fintech disruptors.",
    solution: "TECHSPR implemented a cloud-native core banking platform with mobile-first customer experience, AI-powered personalization, and real-time analytics.",
    results: [
      "60% increase in digital customer engagement",
      "50% reduction in transaction processing time",
      "35% decrease in operational costs",
      "4.8/5 customer satisfaction rating"
    ],
    technologies: ["Cloud", "AI/ML", "Mobile", "Microservices"]
  },
  {
    id: "cs-2",
    client: "Fortune 500 Insurance Company",
    industry: "Insurance",
    title: "AI-Powered Claims Processing Reduces Cycle Time by 70%",
    challenge: "Manual claims processing led to long processing times, high operational costs, and poor customer satisfaction.",
    solution: "Implemented an AI-powered intelligent claims processing system with document extraction, fraud detection, and automated decision-making capabilities.",
    results: [
      "70% reduction in claims processing time",
      "40% decrease in fraudulent claims",
      "25% improvement in customer satisfaction",
      "$15M annual cost savings"
    ],
    technologies: ["AI", "Machine Learning", "RPA", "Document AI"]
  },
  {
    id: "cs-3",
    client: "Healthcare Network",
    industry: "Healthcare",
    title: "Patient Engagement Platform Improves Care Outcomes by 45%",
    challenge: "Fragmented patient data and poor care coordination led to suboptimal patient outcomes and high readmission rates.",
    solution: "Developed an integrated patient engagement platform with EHR integration, telemedicine, remote monitoring, and care coordination tools.",
    results: [
      "45% improvement in patient outcomes",
      "30% reduction in hospital readmissions",
      "85% patient satisfaction score",
      "Seamless care coordination across providers"
    ],
    technologies: ["Healthcare IT", "Telemedicine", "IoT", "Analytics"]
  },
  {
    id: "cs-4",
    client: "Pharmaceutical Company",
    industry: "Life Sciences",
    title: "Clinical Trial Platform Accelerates Drug Development by 40%",
    challenge: "Inefficient clinical trial management and data collection processes delayed drug development timelines.",
    solution: "Built a comprehensive clinical trial management platform with patient recruitment, data collection, regulatory compliance, and real-time analytics.",
    results: [
      "40% faster trial completion",
      "50% improvement in patient recruitment",
      "Enhanced regulatory compliance",
      "Real-time trial insights"
    ],
    technologies: ["Clinical Systems", "AI", "Analytics", "Mobile"]
  },
  {
    id: "cs-5",
    client: "Manufacturing Giant",
    industry: "Industrial",
    title: "IoT-Enabled Predictive Maintenance Reduces Downtime by 65%",
    challenge: "Unplanned equipment downtime resulted in production losses and high maintenance costs.",
    solution: "Implemented an IoT-based predictive maintenance solution with sensor networks, machine learning models, and real-time monitoring dashboards.",
    results: [
      "65% reduction in unplanned downtime",
      "30% decrease in maintenance costs",
      "20% increase in overall equipment effectiveness",
      "Real-time equipment health monitoring"
    ],
    technologies: ["IoT", "Machine Learning", "Edge Computing", "Analytics"]
  },
  {
    id: "cs-6",
    client: "SaaS Provider",
    industry: "Software & Hi-Tech",
    title: "Cloud Migration Enables 10x Scalability and 40% Cost Reduction",
    challenge: "Legacy infrastructure limited scalability and resulted in high operational costs.",
    solution: "Executed a comprehensive cloud migration strategy with containerization, microservices architecture, and DevOps automation.",
    results: [
      "10x improvement in scalability",
      "40% reduction in infrastructure costs",
      "99.99% system availability",
      "50% faster feature deployment"
    ],
    technologies: ["Cloud", "Kubernetes", "Microservices", "DevOps"]
  },
  {
    id: "cs-7",
    client: "Telecom Operator",
    industry: "Telecom & Media",
    title: "5G Network Modernization Drives New Revenue Streams",
    challenge: "Aging network infrastructure and increasing customer demand for 5G services.",
    solution: "Modernized network infrastructure with 5G capabilities, network automation, and edge computing solutions.",
    results: [
      "Successful 5G rollout across 50 cities",
      "35% increase in network capacity",
      "New B2B revenue streams",
      "Improved network reliability"
    ],
    technologies: ["5G", "Network Automation", "Edge Computing", "SDN"]
  },
  {
    id: "cs-8",
    client: "E-Commerce Platform",
    industry: "Consumer Tech",
    title: "Personalization Engine Boosts Conversion Rates by 55%",
    challenge: "Generic user experience led to low conversion rates and high cart abandonment.",
    solution: "Implemented an AI-powered personalization engine with recommendation systems, dynamic pricing, and personalized marketing.",
    results: [
      "55% increase in conversion rates",
      "40% reduction in cart abandonment",
      "2.5x improvement in average order value",
      "Enhanced customer lifetime value"
    ],
    technologies: ["AI", "Machine Learning", "E-commerce", "Analytics"]
  }
];

export const partners = [
  { name: "AWS", logo: "aws", category: "Cloud" },
  { name: "Microsoft", logo: "microsoft", category: "Cloud" },
  { name: "Google Cloud", logo: "google", category: "Cloud" },
  { name: "IBM", logo: "ibm", category: "Technology" },
  { name: "Salesforce", logo: "salesforce", category: "CRM" },
  { name: "ServiceNow", logo: "servicenow", category: "Automation" },
  { name: "Red Hat", logo: "redhat", category: "Open Source" },
  { name: "NVIDIA", logo: "nvidia", category: "AI" },
  { name: "Databricks", logo: "databricks", category: "Data" },
  { name: "Snowflake", logo: "snowflake", category: "Data" },
  { name: "UiPath", logo: "uipath", category: "Automation" },
  { name: "Appian", logo: "appian", category: "Low-Code" },
  { name: "OutSystems", logo: "outsystems", category: "Low-Code" },
  { name: "Boomi", logo: "boomi", category: "Integration" },
  { name: "Mambu", logo: "mambu", category: "Banking" },
  { name: "Harness", logo: "harness", category: "DevOps" },
  { name: "Zscaler", logo: "zscaler", category: "Security" },
  { name: "Software AG", logo: "softwareag", category: "Integration" }
];

export const insights = [
  {
    id: "blog-1",
    type: "blog",
    title: "The Future of AI in Enterprise: 2025 Trends and Predictions",
    excerpt: "Explore how artificial intelligence is reshaping enterprise operations and what to expect in the coming years.",
    author: "Dr. Sarah Chen",
    date: "2025-07-15",
    readTime: "8 min read",
    category: "AI & Innovation"
  },
  {
    id: "blog-2",
    type: "blog",
    title: "Cloud Migration Best Practices: Lessons from 100+ Successful Transformations",
    excerpt: "Learn from real-world cloud migration experiences and avoid common pitfalls.",
    author: "Michael Rodriguez",
    date: "2025-07-10",
    readTime: "10 min read",
    category: "Cloud"
  },
  {
    id: "whitepaper-1",
    type: "whitepaper",
    title: "Digital Transformation Playbook for Financial Services",
    excerpt: "A comprehensive guide to navigating digital transformation in banking and financial services.",
    date: "2025-06-28",
    pages: "42 pages",
    category: "Financial Services"
  },
  {
    id: "news-1",
    type: "news",
    title: "TECHSPR Named Leader in 2025 Digital Engineering Services Report",
    excerpt: "Industry analyst recognizes TECHSPR's excellence in digital engineering and enterprise modernization.",
    date: "2025-07-20",
    category: "Company News"
  },
  {
    id: "press-1",
    type: "press-release",
    title: "TECHSPR Announces Strategic Partnership with Leading Cloud Provider",
    excerpt: "Partnership aims to accelerate enterprise cloud adoption and AI innovation.",
    date: "2025-07-18",
    category: "Press Release"
  },
  {
    id: "event-1",
    type: "event",
    title: "TECHSPR Innovation Summit 2025",
    excerpt: "Join us for our annual innovation summit featuring keynotes from industry leaders and hands-on workshops.",
    date: "2025-09-15",
    location: "San Francisco, CA",
    category: "Event"
  }
];

export const team = [
  {
    name: "James Mitchell",
    role: "Chief Executive Officer",
    bio: "James brings 25+ years of technology leadership experience, driving innovation and growth across global markets.",
    image: "ceo"
  },
  {
    name: "Dr. Priya Sharma",
    role: "Chief Technology Officer",
    bio: "Dr. Sharma leads TECHSPR's technology vision with expertise in AI, cloud computing, and enterprise architecture.",
    image: "cto"
  },
  {
    name: "Robert Chen",
    role: "Chief Operating Officer",
    bio: "Robert oversees global operations, ensuring delivery excellence and operational efficiency across all service lines.",
    image: "coo"
  },
  {
    name: "Lisa Anderson",
    role: "Chief Financial Officer",
    bio: "Lisa drives financial strategy and investor relations, supporting TECHSPR's sustainable growth trajectory.",
    image: "cfo"
  },
  {
    name: "David Kim",
    role: "Chief Strategy Officer",
    bio: "David shapes TECHSPR's strategic direction, identifying growth opportunities and market expansion strategies.",
    image: "cso"
  },
  {
    name: "Maria Garcia",
    role: "Chief People Officer",
    bio: "Maria leads talent strategy, fostering a culture of innovation, diversity, and continuous learning.",
    image: "cpo"
  }
];

export const locations = [
  {
    region: "North America",
    offices: [
      { city: "San Francisco", country: "USA", type: "Headquarters" },
      { city: "New York", country: "USA", type: "Regional Office" },
      { city: "Toronto", country: "Canada", type: "Delivery Center" }
    ]
  },
  {
    region: "Europe",
    offices: [
      { city: "London", country: "UK", type: "Regional HQ" },
      { city: "Frankfurt", country: "Germany", type: "Innovation Lab" },
      { city: "Dublin", country: "Ireland", type: "Delivery Center" }
    ]
  },
  {
    region: "Asia Pacific",
    offices: [
      { city: "Bangalore", country: "India", type: "Global Delivery Center" },
      { city: "Singapore", country: "Singapore", type: "Regional HQ" },
      { city: "Sydney", country: "Australia", type: "Regional Office" },
      { city: "Tokyo", country: "Japan", type: "Innovation Hub" }
    ]
  },
  {
    region: "Middle East",
    offices: [
      { city: "Dubai", country: "UAE", type: "Regional Office" }
    ]
  }
];

export const awards = [
  {
    title: "Leader in Digital Engineering Services",
    organization: "ISG Provider Lens 2025",
    year: "2025"
  },
  {
    title: "Top 10 AI Services Provider",
    organization: "Forrester Wave",
    year: "2025"
  },
  {
    title: "Best Employer for Innovation",
    organization: "Fortune Magazine",
    year: "2025"
  },
  {
    title: "Excellence in Cloud Transformation",
    organization: "Gartner",
    year: "2024"
  }
];

export const careers = [
 
  {
    id: "job-1",
    title: "Business Development Associate",
    location: "Greater Noida, India / Remote",
    department: "Business Development",
    type: "Full-time",
    description: "Identify new business opportunities, generate leads, connect with potential clients, and support the sales team in expanding the company's customer base.",
    link: "https://careers.techspr.net/jobs/business-development-associate/"
  },
  {
    id: "job-2",
    title: "Business Development Team Leader",
    location: "Greater Noida, India / Remote",
    department: "Business Development",
    type: "Full-time",
    description: "Lead and manage a team of Business Development Associates, monitor sales performance, guide the team in lead generation, and help achieve business growth targets.",
    link: "https://careers.techspr.net/jobs/business-development-team-leader/"
  },
  {
    id: "job-3",
    title: "Business Development Manager",
    location: "Greater Noida, India / Remote",
    department: "Business Development",
    type: "Full-time",
    description: "Develop business growth strategies, manage key client relationships, explore new markets, and oversee the business development team to drive revenue.",
    link: "https://careers.techspr.net/jobs/sales-manager/"
  }

  // {
  //   id: "job-4",
  //   title: "Data Scientist",
  //   location: "New York, NY",
  //   department: "Data & Analytics",
  //   type: "Full-time",
  //   description: "Build advanced analytics and ML models for enterprise clients."
  // },
  // {
  //   id: "job-5",
  //   title: "UX Designer",
  //   location: "Singapore / Remote",
  //   department: "Design",
  //   type: "Full-time",
  //   description: "Create exceptional user experiences for enterprise applications."
  // },
  // {
  //   id: "job-6",
  //   title: "DevOps Engineer",
  //   location: "Toronto, Canada",
  //   department: "Engineering",
  //   type: "Full-time",
  //   description: "Build and maintain CI/CD pipelines and infrastructure automation."
  // }
];

export const values = [
  {
    title: "Innovation First",
    description: "We continuously push boundaries and embrace new technologies to deliver cutting-edge solutions.",
    icon: "Lightbulb"
  },
  {
    title: "Client Success",
    description: "Our clients' success is our success. We're committed to delivering measurable business value.",
    icon: "Target"
  },
  {
    title: "Excellence",
    description: "We maintain the highest standards of quality in everything we do, from code to client service.",
    icon: "Award"
  },
  {
    title: "Integrity",
    description: "We operate with transparency, honesty, and ethical principles in all our relationships.",
    icon: "Shield"
  },
  {
    title: "Collaboration",
    description: "We believe in the power of teamwork and foster a culture of open communication and knowledge sharing.",
    icon: "Users"
  },
  {
    title: "Diversity & Inclusion",
    description: "We celebrate diversity and create an inclusive environment where everyone can thrive.",
    icon: "Heart"
  }
];